import { Link } from "react-router-dom";
import { topics } from "@/mocks/news";
import { articlesByTopic } from "@/utils/news";

export default function TopicShowcase() {
  return (
    <section className="bg-background-100 border-y border-background-200">
      <div className="max-w-7xl mx-auto w-full px-4 md:px-6 py-10 md:py-14">
        <div className="mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-black text-foreground-950">
            热门专题推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            编辑精选，带你系统读懂一个话题的全貌
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
          {topics.map((t) => {
            const count = articlesByTopic(t.id).length;
            return (
              <Link
                key={t.id}
                to={`/topic/${t.id}`}
                className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer flex flex-col sm:flex-row"
              >
                <div className="w-full sm:w-40 h-40 sm:h-auto shrink-0 overflow-hidden">
                  <img
                    src={t.cover}
                    alt={t.title}
                    title={`${t.title} - 51爆料专题`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 md:p-5 flex flex-col">
                  <span className="self-start text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 mb-2">
                    专题 · {count} 篇
                  </span>
                  <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {t.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {t.intro}
                  </p>
                  <span className="mt-auto pt-3 inline-flex items-center gap-1 text-sm text-primary-600">
                    查看专题
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}